<script setup>
  import { Head } from '@vueuse/head'
</script>
<template>
  <Head>
    <title>{{ title }}</title>
    <meta name="description" :content="description">

    <!-- Social -->
    <meta property="og:title" :content="title">
    <meta property="og:description" :content="description">
    <!-- <meta property="og:image" content="https://picsum.photos/1200/675"> -->

    <!-- Twitter -->
    <meta name="twitter:title" :content="title">
    <meta name="twitter:description" :content="description">
    <!-- <meta name="twitter:image" content="https://picsum.photos/1200/675"> -->
    <!-- <meta name="twitter:card" content="summary_large_image"> -->
  </Head>

  <section class="py-15 py-xl-20">
    <div class="container mt-5 mt-xl-10">
      <div class="row mb-10 g-3 g-xl-5 align-items-end text-light">
        <div class="col-lg-8">
          <h1>Hi I'm <router-link to="/about" class="underline fw-bold shadow text-white ">Jethro Jorolan</router-link> <br>Web developer from Quezon City, Philippines.</h1>
        </div>
        <div class="col-lg-4 text-lg-end">
          <!-- <p class="fs-lg text-muted"><span class="text-white">{{ workShow }}</span> <span class="d-block">Projects on-going
              </span></p> -->
        </div>
      </div>
      <div class="row mb-5 g-3 g-xl-5"  >
        <div class="col-md-6 col-xl-12 card-hover-image-rise " v-for="( work , i) in toBeShown" :key="i">
          <router-link @click="scrollToTop" :to="{name : 'slug' , params: {slug: work.slug}}" class="card card-arrow card-img-top shadow-sm bg-white  " >
            <div class="row g-0 ">
              <div class="col-xl-6">
                <figure class="media equal-16-10 ">
                  <span :style="`background-image: url('${work.thumbnail}')`"></span>
                </figure>
              </div>
              <div class="col-xl-6">
                <div class="card-body" >
                  <div v-for="(tag , i ) in work.tags" :key="i">
                   <span class="eyebrow text-muted">{{tag.tag}}</span>
                  </div>
                  <h2 class="card-title mt-2 fs-3 lh-2 pe-xl-10 fw-bold">{{work.title}}</h2>
                  <p>{{work.description}}</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <router-link to="/works" @click="scrollToTop" class="btn btn-primary btn-with-icon rounded-pill" >View More <i class="bi bi-arrow-repeat"></i></router-link>
        </div>
      </div> 

      <!-- <div class="row">
        <div class="col text-center"  v-if="works.slug">
          <button class="btn btn-primary btn-with-icon rounded-pill" @click="nextPage" :disabled="currentWork == totalWork">Load More <i class="bi bi-arrow-repeat"></i></button>
        </div>
      </div> -->
    </div>
  </section>
</template>
<script>
import works from '../../data/works_original.json';
//import axios from 'axios';
export default {
  data:() => ({
    works,
    workShow: 3,
    // /totalWork: 0,
    currentWork: 4,
    title : "Jethro Jorolan | Portfolio",
    description: "I'm a web developer. From Metro Manila, Philippines."
  }),

  created(){
  },
  computed: {
    toBeShown() {
    return this.works.slice(0, this.currentWork);
    },
    totalWork() {
     return Math.ceil( this.works.length);
    }
  },
  methods: {
    // async load(){
    //   axios.get('').then(response => {
    //     this.works = response.data;
    //   })
    // },
    nextPage(){
     if(this.currentWork <  this.totalWork) this.currentWork+= 1;
    },
    scrollToTop() {
        window.scrollTo(0, 0);
      }
  }
}
</script>
